import { Box, CircularProgress, Container, Grid } from '@mui/material';
// import { experimentalStyled as styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import {
  ADD_DISCOVER_DATA,
  INIT_CATEGORY_DATA,
  UPDATE_DISCOVER_DATA
} from '../../../redux/constants';
import DiscoverClassCard from '../../../components/DiscoverClassCard';
import Page from '../../../components/Page';
// import DiscoverBanner from './DiscoverBanner';
// import DiscoverSidebar from './DiscoverSidebar';
import { API_LIMIT_DATA, searchFilter } from '../../../utils/constants';
import { useDiscoverSearchAuth } from '../../../context/DiscoverSearchContext';
import EmptyDashboardChart from '../../../components/EmptyDashboardChart';
import { searchClasses } from '../../../service/discoverSearch.service';
import DiscoverCategory from './DiscoverCategory';
import Header from '../../../components/Header';
import { fetchDiscoverSideMenu } from '../../../service/discover.service';
// import discoverBanner from '../../../svg/discover_banner.svg';

// const MainStyle = styled('div')(({ theme }) => ({
//   flexGrow: 1,
//   overflow: 'auto',
//   minHeight: '100%',
//   [theme.breakpoints.up('lg')]: {
//     paddingLeft: theme.spacing(2),
//     paddingRight: theme.spacing(2)
//   }
// }));

export default function StudentDiscover() {
  const categoryData = useSelector((state) => state.discover.categories);
  // discover list
  const discoverData = useSelector((state) => state.discover.list);
  // offset
  const offset = useSelector((state) => state.discover.offset);
  // hasmore
  const hasMore = useSelector((state) => state.discover.hasMore);
  // loading
  const [loading, setLoading] = useState(categoryData === null);
  // data loading
  const [isDataLoading, setIsDataLoading] = useState(false);
  // search value
  const { searchValue } = useDiscoverSearchAuth();
  // dispatch
  const dispatch = useDispatch();
  // display classes
  const [isDisplayClasses, setDisplayClasses] = useState(false);
  // class header
  const [classHeading, setClassHeading] = useState('');

  // This will call first time when we don't have value for categoryData in redux state
  useEffect(() => {
    const fetchCategoryData = async () => {
      const res = await fetchDiscoverSideMenu();
      if (res) {
        dispatch({
          type: INIT_CATEGORY_DATA,
          payload: {
            data: res.results
          }
        });
      }
      setLoading(false);
    };
    if (categoryData === null) fetchCategoryData();
  }, []);

  // When search value changes then this effect will take in place
  useEffect(() => {
    if (searchValue) {
      setDisplayClasses(true);
      setClassHeading(searchValue);
    }

    if (searchValue === '') {
      setDisplayClasses(false);
      setClassHeading('');
    }
  }, [searchValue]);

  useEffect(() => {
    const getDiscoverList = async () => {
      // const res = await fetchDiscoverList(API_LIMIT_DATA, offset);
      const res = await searchClasses(classHeading, API_LIMIT_DATA, offset, searchFilter);
      if (res) {
        dispatch({
          type: ADD_DISCOVER_DATA,
          payload: {
            data: res.hits,
            offset: offset + 1
          }
        });
      }
      // setLoading(false);
    };

    if (discoverData === null) getDiscoverList();
    else setLoading(false);
  }, []);

  const fetchNextData = async () => {
    if (hasMore) {
      const res = await searchClasses(classHeading, API_LIMIT_DATA, offset, searchFilter);
      if (res) {
        dispatch({
          type: UPDATE_DISCOVER_DATA,
          payload: {
            data: res.hits,
            offset: offset + 1
          }
        });
      }
      setIsDataLoading(false);
    }
  };

  return (
    <Page title="Discover">
      <Box position="relative">
        {/* <DiscoverBanner /> */}
        <Container>
          {loading ? (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="100%"
              width="100%"
              pt={{
                xs: 20,
                md: 0
              }}
              overflow="hidden"
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              {!isDisplayClasses && (
                <DiscoverCategory
                  handleDisplayClasses={(name) => {
                    setClassHeading(name);
                    setDisplayClasses(true);
                  }}
                />
              )}
              {isDisplayClasses && (
                <>
                  <Header onBack={() => setDisplayClasses(false)} title={classHeading} />
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={() => {
                      if (hasMore && !isDataLoading) {
                        fetchNextData();
                        setIsDataLoading(true);
                      }
                    }}
                    hasMore={hasMore}
                    loader={
                      <Box
                        my={4}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                      >
                        <CircularProgress />
                      </Box>
                    }
                  >
                    {discoverData === null ? (
                      <EmptyDashboardChart text="Classes not found" />
                    ) : (
                      <Grid container spacing={2} mb={2}>
                        {discoverData.map((dd) => (
                          <Grid item sm={4} md={4} xs={12} key={dd._id}>
                            <DiscoverClassCard classData={dd} />
                          </Grid>
                        ))}
                      </Grid>
                    )}
                  </InfiniteScroll>
                </>
              )}
            </>
          )}
          {/* <Stack direction="row" spacing={{ xs: 0 }} position="relative">
            <DiscoverSidebar />
            <MainStyle>
              {loading ? (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                  width="100%"
                  pt={{
                    xs: 20,
                    md: 0
                  }}
                  overflow="hidden"
                >
                  <CircularProgress />
                </Box>
              ) : (
                <InfiniteScroll
                  pageStart={0}
                  loadMore={() => {
                    if (hasMore && !isDataLoading) {
                      fetchNextData();
                      setIsDataLoading(true);
                    }
                  }}
                  hasMore={hasMore}
                  loader={
                    <div className="loader" key={0}>
                      Loading ...
                    </div>
                  }
                >
                  {discoverData === null ? (
                    <EmptyDashboardChart text="Classes not found" />
                  ) : (
                    <>
                      <Grid container spacing={2}>
                        {discoverData.map((dd) => (
                          <Grid item sm={6} md={6} xs={12} key={dd._id}>
                            <DiscoverClassCard classData={dd} />
                          </Grid>
                        ))}
                      </Grid>
                    </>
                  )}
                </InfiniteScroll>
              )}
            </MainStyle>
          </Stack> */}
        </Container>
      </Box>
    </Page>
  );
}
